import React from "react";

import ShowCalls from "../../CallsMaster/ShowCalls";

const Admin = () => {
  return (
    <>
    
    
    <ShowCalls/>
      {/* <h1>Admin Pannel</h1>
      <Link className="nav-link text-dark" to="/UserRegister">
        UserRegister
      </Link>
      <Link className="nav-link text-dark" to="/ShowRestorant">
        Show Restorant
      </Link>
      <Link className="nav-link text-dark" to="/ShowOutlate">
        Show Outlate
      </Link>
      <Link className="nav-link text-dark" to="/ShowCalls">
        Show Calls
      </Link>
      <Link className="nav-link text-dark" to="/SupportEnggMessage">
        SupportEnggMessage
      </Link>
      <Link className="nav-link text-dark" to="/AdminCallCloseStatus">
        Call Close Status
      </Link>
      <Link className="nav-link text-dark" to="/ShowNewCall">
        Show New CreatedCall
      </Link>
      <Link className="nav-link text-dark" to="/CreateUserWiseRestOutlet">
        CreateUserWiseRest&Outlate
      </Link> */}
    </>
  );
};

export default Admin;
